// extracted by mini-css-extract-plugin
export default {"CardBaseWithSash":"index-module__CardBaseWithSash--bKWdb","dragDisabled":"index-module__dragDisabled--HvTfV","isRedacted":"index-module__isRedacted--jgk3n"};